import { useMemo } from "react";

import { Divider } from "@mui/material";
import { Box } from "@mui/system";

import { useAuthContext } from "../../../Context/AuthContext";
import { useCustomerContext } from "../../../Context/CustomerContext";
import { useIsFeatureEntitled } from "../../../Context/TierProvider";
import { useAnnounceKit } from "../../../utils/announcekit/announcekitHooks";
import { type CategoryContext } from "../../types";
import { AVAButton } from "./AVAButton";
import HelpMenu from "./HelpMenu";
import { InAppNotifications } from "./InAppNotifications/InAppNotifications";
import { SettingsMenu } from "./Settings/SettingsMenu";

type Props = {
  hideWhatsNewOption: boolean;
  settings: CategoryContext[];
  isSubMenuItemSelected: boolean;
};

// 3 options on nav bar: What's new, settings and help menu
export const AdditionalOptions = ({ hideWhatsNewOption, settings, isSubMenuItemSelected }: Props) => {
  const { customer, customerOrPresentationModeCustomer } = useCustomerContext({ allowNull: true });
  const { unread } = useAnnounceKit();
  const { isDoitEmployee } = useAuthContext();
  const isEntitledAvaIcon = useIsFeatureEntitled("platform:ava:icon");

  const canHaveAva = useMemo<boolean>(() => isDoitEmployee || !!isEntitledAvaIcon, [isDoitEmployee, isEntitledAvaIcon]);

  return (
    <>
      <Box
        sx={{
          px: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        {canHaveAva && <AVAButton />}
        {customer && customerOrPresentationModeCustomer && (
          <InAppNotifications isSubMenuItemSelected={isSubMenuItemSelected} />
        )}
        <HelpMenu hideWhatsNewOption={hideWhatsNewOption} whatsNewUnread={unread} customerId={customer?.id || null} />
        {settings.length > 0 && <SettingsMenu settingsCategory={settings[0]} />}
      </Box>
      <Divider style={{ backgroundColor: "grey" }} orientation="vertical" flexItem />
    </>
  );
};
